// Glitter suspended in a soft translucent body. Each flake is bound to a point
// inside the dough and follows it with a lag, so pressing sends the glitter
// drifting a moment later before it settles. sparkle rises with flake motion.
function random(seed){let s=seed>>>0||1;return()=>{s=(s+0x6D2B79F5)>>>0;let t=s;t=Math.imul(t^(t>>>15),t|1);t^=t+Math.imul(t^(t>>>7),t|61);return((t^(t>>>14))>>>0)/4294967296;};}
export class GlitterField{
  constructor({count,center,radii,seed=1,lag=.22}){
    const rand=random(seed);this.count=count;this.lag=lag;this.points=[];this.angles=[];
    this.floor=center[1]-radii[1]*.9;this.settle=0;
    while(this.points.length<count){
      const p=[rand()*2-1,rand()*2-1,rand()*2-1];
      if(p[0]**2+p[1]**2+p[2]**2>.85)continue;
      this.points.push(p.map((n,a)=>center[a]+n*radii[a]));
      this.angles.push([rand()*Math.PI*2,rand()*Math.PI*2,rand()*Math.PI*2]);
    }
    this.positions=this.points.map(p=>[...p]);this.sparkle=0;
  }
  step(dt,targets){
    if(!(dt>0))return;
    const k=1-Math.exp(-dt/this.lag);let motion=0;
    // Calm dough lets the glitter sink slowly (over several seconds); motion
    // stirs it back up much faster. settle is the shared 0..1 sinking state.
    const stirring=this.sparkle>.12;
    this.settle+=stirring?-this.settle*(1-Math.exp(-dt/.35)):(1-this.settle)*(1-Math.exp(-dt/(this.settle<.05?9:5)))*Math.min(1,this.calm=(this.calm??0)+dt);
    for(let i=0;i<this.count;i++){
      const p=this.positions[i],bound=targets[i];
      const t=[bound[0],bound[1]-(bound[1]-this.floor)*.55*this.settle,bound[2]];let d=0;
      for(let a=0;a<3;a++){const m=(t[a]-p[a])*k;p[a]+=m;d+=m*m;}
      const speed=Math.sqrt(d)/dt;motion+=speed;
      // Flakes tumble while they drift, which is what makes them glint.
      this.angles[i][0]+=speed*dt*9;this.angles[i][1]+=speed*dt*6;
    }
    this.sparkle=Math.min(1,motion/this.count*.9);
    if(stirring)this.calm=0;
  }
}
